export const SURVEY_CONTENT_WIDTH = 640;

const SURVEY_SIDE_NAVIGATION_WIDTH = 80;
const SURVEY_SIDE_NAVIGATION_GAP = 16;

export const getSurveySideNavigationOffset = (viewportWidth: number): number =>
  (viewportWidth - SURVEY_CONTENT_WIDTH) / 2
  - SURVEY_SIDE_NAVIGATION_GAP
  - SURVEY_SIDE_NAVIGATION_WIDTH;

export const canShowSurveySideNavigation = (viewportWidth: number): boolean =>
  getSurveySideNavigationOffset(viewportWidth) >= 0;
